<template>
  <table class="table b-table">
    <slot />
  </table>
</template>

<style lang="scss">
@import '~@ui/styles/src/scss/utils/lib';

.table-dark .spinner::after {
  border: 2px solid $grey-50;
  border-left-color: transparent;
}
</style>
